import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { DefaultLangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { debounceTime, Subject, Subscription } from 'rxjs';

import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { WertComponent } from '../../modals/wert/wert.component';
import { EventService } from '../../services/event.service';
import { PopupService } from '../../services/popup.service';
import { convertNum, SwapStatus } from '../../shared/constants/app-enums';
import { nativeList, tokenList } from '../../shared/constants/widget-enum';
import { WalletConnectService } from '../../services/wallet-connect.service';
import { getChainData, getDynamicAmountv2, getNativeAmountV2, getUSDTAmount } from '../../shared/constants/wallet-connect.const';
import { balanceData, stakeData, tokenData } from '../../shared/interfaces/wallet.interface';
import { IChainData } from '../../shared/interfaces/common.interface';
import { BuyETHWertComponent } from '../../modals/eth-buy-wert/buy-eth-wert.component';

@Component({
  selector: 'app-swap',
  templateUrl: './swap.component.html',
  styleUrls: ['./swap.component.scss'],
})
export class SwapComponent implements OnInit {
  @Input() isNative: boolean = false;
  @Input() isWert: boolean = false;
  @Input() isModal: boolean = false;
  @Output() messageEvent = new EventEmitter<boolean>();
  @ViewChild('swapIn') swapIn: ElementRef<HTMLInputElement> | null = null;
  @ViewChild('dropDownBtn') dropDownBtn: ElementRef<HTMLButtonElement> | null = null;

  private subscriptions: Subscription[] = [];
  environtment = environment;
  baseToken?: number;
  swapToken?: number;
  swapTokenUpdate = new Subject<number | undefined>();
  baseTokenUpdate = new Subject<number | undefined>();
  currentLang!: string;
  SwapStatus = SwapStatus;
  lblockPrice = 0;
  isLowBalance = false;
  inProgress = false;

  isStake = false;
  usdtBal: number = 0;
  usdcBal: number = 0;
  nativeBal: number = 0;
  minAmount = environment.minToken;

  modalRef?: BsModalRef;
  lowGas = false;
  wertMode: boolean = false;

  chainData!: IChainData;
  salePrice!: number;
  modeName: string = '';
  walletAddress: string = '';
  status!: SwapStatus;
  hash!: string;
  tokenName: string = '';
  gasFees!: number;
  maxTokensToBuy?: number;
  cryptoName = environment.tokenName;
  stakeData!: stakeData;
  allBalance: { native: number; usdt: number; usdc: number | null } = { native: 0, usdt: 0, usdc: 0 };
  selectedTab: string = 'ALL'; // Default selected tab
  activeToken!: tokenData; // Default active token
  tokenList: Array<tokenData> = [];
  tokenFilteredList: Array<tokenData> = [];
  tokensData = tokenList;
  chainId: number = 0;
  balanceData: balanceData = {} as balanceData;

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private walletConnectService: WalletConnectService,
    private http: HttpClient,
    private eventService: EventService,
    private modalService: BsModalService,
    private translate: TranslateService,
    private popupService: PopupService,
    private router: Router,
  ) {
    this.currentLang = this.translate.currentLang;
    this.translate.onLangChange.subscribe((params: DefaultLangChangeEvent) => {
      this.currentLang = params.lang || 'en';
    });

    this.eventService.getNetwork().subscribe((val) => {
      this.getBal();
      if (!this.isWert) this.max();
    });

    //to check the value of swap
    this.subscriptions.push(
      this.swapTokenUpdate
        .pipe(
          debounceTime(500),
          // distinctUntilChanged()
        )
        .subscribe((value) => {
          if (this.swapToken && this.swapToken >= 0) {
            this.calculateSwap();
          } else {
            this.baseToken = 0;
          }
        }),
    );
    this.subscriptions.push(
      this.baseTokenUpdate
        .pipe(
          debounceTime(500),
          // distinctUntilChanged()
        )
        .subscribe((value) => {
          if (this.baseToken && this.baseToken >= 0) {
            this.calculateSwapReverse();
          } else {
            this.swapToken = 0;
          }
        }),
    );
  }

  ngOnChanges(): void {
    setTimeout(() => {
      this.swapToken = undefined;
      this.baseToken = undefined;
      this.walletConnectService.swapStatus = SwapStatus.not_started;
      this.isLowBalance = false;
      this.lowGas = false;
      this.getBal();
      this.checkLowBalance();
      this.updateAllgetMethod();
      if (!this.isWert && !this.isModal) this.max();
    }, 600);
  }

  ngOnInit(): void {
    this.walletConnectService.swapStatus = SwapStatus.not_started;
    this.isLowBalance = false;
    this.tokenList = [...nativeList.map((x) => x), ...this.tokensData.map((x) => x)];
    // this.tokenList = [...nativeList.map((x) => x)];
    this.tokenList.sort(({ tokenUsdVal: a }, { tokenUsdVal: b }) => b - a);
    // console.log('tokenList =', this.tokenList)
    this.setTab(this.selectedTab, undefined, false);
    if (isPlatformBrowser(this._platformId)) {
      setInterval(() => {
        this.getBal();
        this.updateAllgetMethod();
      }, 500);

      if (this.isModal) this.changeTab('ETH', 'ETH');
    }
  }

  async max() {
    let isNative = this.activeToken?.symbol == 'BNB' || this.activeToken?.symbol == 'ETH';
    let maxVal = 0;
    const balanceData_ = this.walletConnectService.balanceData;
    const chainId = this.chainData?.chainIdInt;

    if (isNative) {
      maxVal = await getDynamicAmountv2(this.maxTokensToBuy! * 1.01, this.activeToken?.symbol, this.activeToken?.category, this.tokensData, chainId, balanceData_);
    } else if (this.activeToken?.symbol == 'USDT') {
      maxVal = await getDynamicAmountv2(this.maxTokensToBuy!, 'USDT', this.activeToken.category, this.tokensData, chainId, balanceData_);
    } else if (this.activeToken?.symbol == 'USDC') {
      maxVal = await getDynamicAmountv2(this.maxTokensToBuy!, 'USDT', this.activeToken.category, this.tokensData, chainId, balanceData_);
    } else {
      maxVal = await getDynamicAmountv2(this.maxTokensToBuy!, this.activeToken?.symbol, this.activeToken?.category, this.tokensData, chainId, balanceData_);
    }

    this.swapToken = +this.floorString((isNative ? (this.activeToken?.tokenBalance - this.gasFees > 0 ? this.activeToken?.tokenBalance - this.gasFees : 0) : this.activeToken?.tokenBalance).toString());

    if (maxVal < this.swapToken) {
      this.swapToken = maxVal;
    }
    if (this.swapToken == 0) {
      this.swapToken = 0;
      this.baseToken = 0;
    } else {
      this.swapToken = Math.floor(this.swapToken * Math.pow(10, this.activeToken.desCount)) / Math.pow(10, this.activeToken.desCount);
      this.swapTokenUpdate.next(this.swapToken);
    }
    if (this.isWert) this.swapToken = undefined;
    setTimeout(() => this.swapTokenUpdate.next(this.swapToken), 200);
  }

  getBal() {
    this.nativeBal = this.allBalance.native;
    this.usdtBal = this.allBalance.usdt;
    this.usdcBal = this.allBalance.usdc as number;

    this.balanceData = this.walletConnectService.balanceData;
    this.chainId = this.walletConnectService.chainId;
    let ethPrice = this.balanceData.ethUsdt / (this.balanceData.oneEth * 1000000);
    let bnbPrice = this.balanceData.ethUsdt / (this.balanceData.oneBnb * 1000000);
    this.tokenList = [...nativeList.map((x) => x), ...this.tokensData.map((x) => x)];
    this.tokenList[0].tokenBalance = this.balanceData.ethBal;
    this.tokenList[1].tokenBalance = this.balanceData.ethUsdtBal;
    this.tokenList[2].tokenBalance = this.balanceData.ethUsdcBal;
    this.tokenList[3].tokenBalance = this.balanceData.bscBal;
    this.tokenList[4].tokenBalance = this.balanceData.bscUsdtBal;
    this.tokenList[5].tokenBalance = this.balanceData.bscUsdcBal;
    this.tokenList[0].tokenUsdVal = this.balanceData.ethBal * ethPrice;
    this.tokenList[1].tokenUsdVal = this.balanceData.ethUsdtBal;
    this.tokenList[2].tokenUsdVal = this.balanceData.ethUsdcBal;
    this.tokenList[3].tokenUsdVal = this.balanceData.bscBal * bnbPrice;
    this.tokenList[4].tokenUsdVal = this.balanceData.bscUsdtBal;
    this.tokenList[5].tokenUsdVal = this.balanceData.bscUsdcBal;

    for (let i = 6; i < this.tokenList.length; i++) {
      let tokenNativePrice = this.tokenList[i].category == 'ETH' ? ethPrice : bnbPrice;
      this.tokenList[i].tokenUsdVal = (tokenNativePrice * this.tokenList[i].tokenBalance) / this.tokenList[i].tokenPerNative!;
    }
    this.tokenList.sort(({ tokenUsdVal: a }, { tokenUsdVal: b }) => b - a);
  }

  updateAllgetMethod(): void {
    this.chainData = getChainData(this.walletConnectService.chainId) as IChainData;
    this.modeName = this.chainData.purchaseToken;
    this.walletAddress = this.walletConnectService.walletAddress;
    this.status = this.walletConnectService.swapStatus;
    this.hash = this.walletConnectService.swapHash;
    this.isNative = this.activeToken.symbol !== 'USDT' && this.activeToken.symbol !== 'USDC' && !this.isWert;
    this.tokenName = this.isWert ? 'USD' : this.activeToken.symbol;
    this.gasFees = this.activeToken.category === 'ETH' ? environment.eth.gasFees : environment.bsc.gasFees;
    this.maxTokensToBuy = this.walletConnectService.balanceData.maxTokensToBuy;
    this.cryptoName = environment.tokenName;
    this.stakeData = this.walletConnectService.stakeData;

    const currentStep = this.walletConnectService.balanceData.currentStep;
    const currentStoreData = this.walletConnectService.tokenomics[currentStep];
    this.salePrice = currentStoreData.tokenUSDT;
    this.allBalance = {
      native: +this.walletConnectService.balanceData.nativeBal.toFixed(10).replace(/0{0,10}$/, ''),
      usdt: this.walletConnectService.balanceData.usdtBal,
      usdc: null,
    };
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  startAgain(): void {
    this.getBal();
    this.updateAllgetMethod();
    this.max();
    this.walletConnectService.swapStatus = SwapStatus.not_started;
  }

  confirm(isBuyStake: boolean = false) {
    this.isStake = isBuyStake;

    if (this.checkChain()) {
      if (this.isWert) {
        this.modalRef = this.modalService.show(WertComponent, {
          class: 'modal-xs modal-dialog-centered transak',
          backdrop: 'static',
          initialState: { walletAddress: this.walletAddress, baseToken: this.baseToken, swapToken: this.swapToken, isStake: this.isStake },
        });
      } else {
        if (this.swapToken !== 0 && (this.baseToken ?? 0) >= this.minAmount) this.createSwap(isBuyStake);
      }
    }
  }

  calculateSwap = async () => {
    this.checkLowBalance();
    // console.log("here", this.activeToken, this.isWert)
    if (this.activeToken.symbol !== 'USDT' && this.activeToken.symbol !== 'USDC' && !this.isWert) {
      this.baseToken = await getNativeAmountV2(+(this.swapToken ?? 0) * 0.99, this.activeToken.symbol, this.balanceData);
    } else {
      this.baseToken = await getUSDTAmount(+(this.swapToken ?? 0) * 0.995, this.chainId, this.balanceData); // hepler function for usdt and usdc are same so can use usdt for usdc as well
    }
    this.baseToken = +this.baseToken.toFixed(0).replace(/0{0,0}$/, '');
  };

  calculateSwapReverse = async () => {
    // console.log("here", this.activeToken, this.isWert)
    if (this.activeToken.symbol !== 'USDT' && this.activeToken.symbol !== 'USDC' && !this.isWert) {
      this.swapToken = await getDynamicAmountv2(this.baseToken ?? 0, this.activeToken.symbol, this.activeToken.category, this.tokensData, this.chainId, this.balanceData);
      this.swapToken = +(this.swapToken * 1.01).toFixed(10).replace(/0{0,10}$/, '');
    } else {
      this.swapToken = await getDynamicAmountv2(this.baseToken ?? 0, 'USDT', this.activeToken.category, this.tokensData, this.chainId, this.balanceData); // hepler function for usdt and usdc are same so can use usdt for usdc as well
      this.swapToken = +(this.swapToken * 1.005).toFixed(10).replace(/0{0,10}$/, '');
    }
    // this.swapToken = Math.floor(this.swapToken * Math.pow(10, this.activeToken.desCount)) / Math.pow(10, this.activeToken.desCount)
    this.checkLowBalance();
  };

  async createSwap(isBuyStake: boolean = false) {
    if (this.inProgress) return;
    this.inProgress = true;
    console.log('createSwap called', this.isNative, this.maxTokensToBuy, this.activeToken);
    if (this.baseToken && this.baseToken <= this.maxTokensToBuy!) {
      this.walletConnectService.swapStatus = SwapStatus.not_started;
      try {
        if (this.activeToken.symbol !== 'USDT' && this.activeToken.symbol !== 'USDC') {
          await this.walletConnectService.swapNativeTokens(this.baseToken ?? 0, this.swapToken ?? 0, isBuyStake);
        } else {
          await this.walletConnectService.swapCryptoForUSDT(this.baseToken ?? 0, this.swapToken ?? 0, false, isBuyStake, this.activeToken.symbol == 'USDC');
        }
        this.inProgress = false;
      } catch (err: any) {
        console.log('createSwap', err);
        if (err && err.code == 4001) {
          this.walletConnectService.swapStatus = SwapStatus.rejected;
        } else {
          this.walletConnectService.swapStatus = SwapStatus.failed;
        }
        this.inProgress = false;
      }
    } else {
      this.popupService.messagePopup({
        icon: 'warning',
        desc: this.translate.instant('widget.max_token_exceed', { maxTokensToBuy: this.maxTokensToBuy }),
        title: this.translate.instant('widget.max_token_title'),
        confirmBtnTxt: this.translate.instant('misc.ok'),
      });
      this.walletConnectService.swapStatus = SwapStatus.not_started;
      this.inProgress = false;
    }
  }

  viewUrl() {
    const blkUrl = this.chainData.blockExplorerURL;
    window.open(blkUrl + this.hash, '_blank');
  }

  checkLowBalance(): void {
    let gas = this.activeToken.chainId == environment.eth.chainIdInt ? environment.eth.gasFees : environment.bsc.gasFees;
    let nativeBal = this.activeToken.chainId == environment.eth.chainIdInt ? this.walletConnectService.balanceData.ethBal : this.walletConnectService.balanceData.bscBal;
    if (this.activeToken.symbol == 'ETH' || this.activeToken.symbol == 'BNB') {
      this.isLowBalance = +this.activeToken.tokenBalance - gas < +(this.swapToken ?? 0);
    } else {
      if (+this.activeToken.tokenBalance >= +(this.swapToken ?? 0) && +nativeBal >= gas) {
        this.isLowBalance = false;
        this.lowGas = false;
      } else {
        this.isLowBalance = true;
        if (nativeBal < this.gasFees) this.lowGas = true;
      }
    }
  }

  openWert(): void {
    this.eventService.broadcastEvent('OPEN_WERT', true);
  }

  checkChain(): boolean {
    if (this.isWert && this.walletConnectService.chainId == environment.eth.chainIdInt) {
      return true;
    }
    if (this.isWert) {
      this.walletConnectService.switchNetwork(environment.eth.chainIdInt);
      return false;
    }
    if (this.walletConnectService.chainId == this.activeToken.chainId) {
      return true;
    } else {
      this.walletConnectService.switchNetwork(this.activeToken.chainId).then(() => {
        return true;
      });
      return false;
    }
  }

  convertNum(amount: number, decimals: number = 2) {
    return convertNum(amount, decimals);
  }

  floorString(str: string) {
    let pos = str.indexOf('.');
    return pos >= 0 ? (str + '00').slice(0, pos + 6) : str + '.00';
  }

  changeTab(tab: string, symbol: string): void {
    const activeCrypto = this.tokenList.find((item: tokenData) => item.category === tab && item.symbol === symbol);
    if (activeCrypto) {
      this.setActiveTab(activeCrypto, tab);
    } else {
      console.error('No active crypto found for the selected tab and symbol.');
    }
    this.messageEvent.emit(false);
    setTimeout(() => this.max(), 1000);
  }

  cardMode(): void {
    this.swapToken = 0;
    this.baseToken = 0;
    this.isNative = false;
    this.messageEvent.emit(true);
  }

  stakeNow(): void {
    this.walletConnectService.switchNetwork(environment.eth.chainIdInt);
    this.router.navigateByUrl(this.currentLang + '/staking', {});
  }

  setTab(tab: string, event?: Event, tabClick: boolean = true) {
    // console.log('setTab called =', tab, event, tabClick,)
    this.selectedTab = tab;

    if (event) {
      event.stopPropagation();
      const TempArr = this.tokenList.filter((item: tokenData) => item.category === tab || tab === 'ALL');
      this.tokenFilteredList = TempArr;
    } else {
      this.tokenFilteredList = this.tokenList.filter((item: tokenData) => item.category === tab || tab === 'ALL');
    }
    // this.tokenFilteredList.sort(({ tokenUsdVal: a }, { tokenUsdVal: b }) => b - a);
    if (!tabClick) this.setActiveTab(this.tokenFilteredList[0], tab);
  }

  async setActiveTab(item: tokenData, tab: string) {
    this.activeToken = item;
    this.activeToken.symbol = this.activeToken.symbol.toString();
    this.isNative = item.symbol === 'USDT' || item.symbol === 'USDC' ? false : true;
    setTimeout(() => this.max(), 1000);
    this.dropDownBtn?.nativeElement.click();

    // change network when chainId is different
    if (item.chainId && this.walletConnectService.chainId !== item.chainId) {
      await this.walletConnectService.switchNetwork(item.chainId);
    }
    // console.log("setActiveTab", this.selectedTab, this.activeToken, tab)
  }

  openEthBuyWidget(isBscChain = false) {
    this.modalRef = this.modalService.show(BuyETHWertComponent, {
      class: 'modal-xs modal-dialog-centered transak',
      backdrop: 'static',
      initialState: { walletAddress: this.walletAddress, isBscChain },
    });
  }
}
